<template>
  <modalWindow v-if="adding" @close="clearMessage();adding=false">
    <div class="titlebar">Gebruiker aanmaken</div>
    <span v-if="msg.msg" :class="['form-' + msg.type]">{{ msg.msg }}</span>
    <form v-show="!creating" @submit.prevent>
      <input type=text ref="name" placeholder="Naam">
      <input type=text ref="username" placeholder="Gebruikersnaam">
      <input type=email ref="email" placeholder="E-mail">
      <select ref="role" placeholder="Role">
        <option value=-1>Lead</option>
        <option value=0>Gebruiker</option>
        <option value=2>Adviseur PLUS</option>
        <option value=8>Beheerder</option>
        <option value=9>Admin</option>
        <option value=10 v-if="$parent.role > 9">Superadmin</option>
      </select>
      <input type=text ref="createport" placeholder="Portefeuille">
      <input type=submit @click="createUser" value="Gebruiker aanmaken">
    </form>
  </modalWindow>
</template>

<script>
export default {
  name: 'AddUser',
  data() {
    return {
      adding: false,
      creating: false,
      msg: { msg: null, type: 'notice' },
    };
  },
  methods: {
    clearMessage() {
      this.msg = { msg: null, type: 'notice' };
    },
    createUser() {
      const emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/g;

      if (
        this.$refs.name.value
        && this.$refs.username.value
        && this.$refs.email.value
        && this.$refs.role.value
      ) {
        if (!emailRegex.test(this.$refs.email.value)) {
          this.msg = { msg: 'Dit is geen geldig e-mailadres.', type: 'error' };
          return;
        }

        let style = 'Velthuyse Mulder';

        if (process.env.VUE_APP_STYLE === 'ox') {
          style = 'OXBY';
        } else if (process.env.VUE_APP_STYLE === 'bvs') {
          style = 'Beer Van Stapele';
        } else if (process.env.VUE_APP_STYLE === 'db') {
          style = 'Doelbeleggen';
        }

        this.$store.state.confirm.toggle({
          text: `Let op: u gaat een gebruiker aanmaken en een e-mail versturen vanuit ${style}, klopt dit?`,
          confirmText: '',
          cancelText: '',
          cb: (confirmed) => {
            if (confirmed) {
              const newPort = this.$refs.createport.value;
              this.creating = true;
              this.msg = { msg: 'Bezig met aanmaken van gebruiker!', type: 'notice' };
              this.sdk.addUser(
                this.$refs.name.value,
                this.$refs.username.value,
                this.$refs.email.value,
                this.$refs.role.value,
                null,
                null,
                (response) => {
                  this.creating = false;
                  if (response.status === 200) {
                    this.msg = { msg: null, type: 'notice' };
                    this.adding = false;
                    if (newPort) {
                      this.sdk.addUserPort(response.data.user, newPort, this.$parent.getUsers);
                    } else {
                      this.$parent.getUsers();
                    }
                  } else {
                    this.msg = { msg: response.data.message, type: 'error' };
                  }
                },
              );
            }
          },
        });
      } else {
        this.msg = { msg: 'Niet alle benodigde velden zijn ingevuld.', type: 'error' };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  form {
    padding: 10px;
    input,
    select,
    button {
      border-radius: 0;
    }
  }
</style>
